import { BlockCommon } from '@shared/interfaces/block.interface';
import { Prettify } from '@shared/utils/types/prettify';

type MergeBlockData<T extends object, U extends object> = T & U;

/**
 * Use it like
 * ```typescript
 * export type CartFunnelFormBlock = DoodBlockModel<{ items: { block: string; position: number }[] }>;
 * ```
 */
export type DoodBlockModel<BlockData extends object = {}> = {
  id: string;
  type: string;
  data?: Prettify<
    MergeBlockData<
      MergeBlockData<{ common?: BlockCommon }, BlockData>,
      keyof BlockData extends string
        ? {}
        : {
            [key: string]: unknown; // Allow other properties
          }
    >
  >;
};

export function createVariablesRecord(variables: { name: string; value: string }[]) {
  return Object.fromEntries(variables.map(({ name, value }) => [name, JSON.parse(value)]));
}
